// Native browser/OS notifications (Option A — works while a browser tab is open,
// including when the tab is in the background). No service worker / push infra.

export function bootstrapNotifyPermission() {
  if (!("Notification" in window)) return;
  if (Notification.permission !== "default") return;
  // Try immediately; if the browser requires a user gesture, retry on first interaction.
  Notification.requestPermission().catch(() => {});
  const once = () => {
    if (Notification.permission === "default") {
      Notification.requestPermission().catch(() => {});
    }
    window.removeEventListener("pointerdown", once);
    window.removeEventListener("keydown", once);
  };
  window.addEventListener("pointerdown", once, { once: true });
  window.addEventListener("keydown", once, { once: true });
}

export function nativeNotify(title, { body, tag, onClick } = {}) {
  try {
    if (!("Notification" in window) || Notification.permission !== "granted") return;
    const n = new Notification(title, {
      body,
      tag,
      icon: "/logo192.png",
      badge: "/logo192.png",
    });
    if (onClick) {
      n.onclick = () => {
        window.focus();
        onClick();
        n.close();
      };
    }
  } catch {
    /* ignore */
  }
}
